<script setup>
const props = defineProps({
  h2: {
    type: String,
    required: true,
  },
  body: {
    type: String,
  },

  cta: {
    type: Object,

    validate: (value) => {
      return typeof value.label === "string" && typeof value.path === "string";
    },
  },
  cta2: {
    type: Object,

    validate: (value) => {
      return typeof value.label === "string" && typeof value.path === "string";
    },
  },
});
</script>

<template>
  <div class="grid grid-cols-1 md:grid-cols-2 items-center relative">
    <!-- Copy -->
    <div>
      <h2
        class="text-4xl font-bold md:text-5xl font-iq-header leading-iq-header tracking-iq-header text-iq-header-color"
      >
        {{ h2 }}
      </h2>
      <slot name="body">
        <p class="mt-6 text-lg text-justify">{{ body }}</p>
      </slot>
      <div class="mt-8">
        <FlexuilibCta
          v-if="cta"
          :label="cta.label"
          :path="cta.path"
          :type="primary"
          :icon="cta.icon"
        />
      </div>
    </div>

    <FlexuilibMockup />
  </div>
</template>
